/**
 * Force-close any open antd overlay with click-to-hide behaviour - Select
 * dropdown, DatePicker panel, Dropdown menu, Cascader, Popconfirm, etc. - by
 * simulating a click outside it.
 *
 * HOW IT WORKS
 * rc-trigger - which all of the above are built on - registers a `mousedown`
 * listener on `document` while a click-triggered popup is open, and closes
 * the popup once that mousedown's target lies outside both the trigger and
 * the popup (see rc-trigger/lib/index.js, `onDocumentClick`). Dispatching a
 * bubbling mousedown directly on `<html>` satisfies exactly that condition.
 *
 * WHY THIS IS SAFE FOR THE REST OF THE APP
 * React 17 attaches its own event listeners to the root container (#root), a
 * DESCENDANT of `<html>`. An event dispatched directly on `<html>` propagates
 * only along [html -> document -> window], never through #root, so no React
 * onMouseDown handler anywhere in the app can observe it - only listeners
 * bound straight to document/window do, which is exactly rc-trigger's.
 */
export const dismissOpenOverlays = () => {
  document.documentElement.dispatchEvent(
    new MouseEvent("mousedown", { bubbles: true, cancelable: true })
  );
};

export default dismissOpenOverlays;
